import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import SetupNavigation from './SetupNavigation';
import GroupInfo from './GroupInfo';
import Inventory from './Inventory';
import Config from './Config';
import GroupNav from '../../GroupNav';

function Setup({ onSubmit, fetching, history, dealers, group, step }) {
  const renderStep = useMemo(() => {
    if (step === 2) {
      return <Inventory onSubmit={onSubmit} group={group} />;
    }
    if (step === 3) {
      return <Config group={group} history={history} />;
    }
    return (
      <GroupInfo
        onSubmit={onSubmit}
        fetching={fetching}
        history={history}
        dealers={dealers}
        group={group}
        step={step}
      />
    );
  }, [step, onSubmit, fetching, history, dealers, group]);

  return (
    <div>
      {!!group?.id && <GroupNav id={group?.id} activeKey="setup" />}
      <div className="group-editor-container">
        <SetupNavigation step={step} history={history} groupId={group.id} />
        {renderStep}
      </div>
    </div>
  );
}

Setup.propTypes = {
  onSubmit: PropTypes.func,
  fetching: PropTypes.bool,
  history: PropTypes.object,
  dealers: PropTypes.array,
  group: PropTypes.object,
  step: PropTypes.number,
};

export default Setup;
